import { useAtomValue } from "jotai";
import { componentConfigAtom } from "./atoms";

import type { PopulatedComponentConfig } from "./types";

export const useComponentConfig = (): PopulatedComponentConfig => {
  return useAtomValue(componentConfigAtom);
};
